const EVENTS = ['created', 'updated', 'deleted', 'response', 'scheduled'];

export const eventLabel = (event, translate) => {
  if (event == null || event === '') return translate('eventNotSelected');
  return translate(EVENTS.includes(event) ? event : 'eventUnknown');
};
